export default "__VITE_ASSET__ed529e3c__"